module.exports = "<div>\n\t<button (click)=\"clickPlay($event)\" class=\"fa fa-play\"></button>\n\t<button (click)=\"clickStop($event)\" class=\"fa fa-pause\"></button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/playhead/playhead.component.html
// module id = ../../../../../src/app/playhead/playhead.component.html
// module chunks = main